import { api } from "./api.ts";
import type { ChangesetView } from "./types.ts";

/**
 * Proposes ops as a changeset and applies it right away: in the browser the
 * person publishing is the one approving. A destructive changeset is left
 * pending so it goes through the review screen with its confirmation.
 */
export async function proposeAndApply(title: string, ops: unknown[]): Promise<{ changeset: ChangesetView; applied: boolean }> {
  const { changeset } = await api<{ changeset: ChangesetView }>("POST", "/v1/changesets", { title, ops });
  if (changeset.risk === "destrutivo") return { changeset, applied: false };
  const r = await api<{ changeset: ChangesetView }>("POST", `/v1/changesets/${changeset.id}/apply`, { hash: changeset.hash });
  return { changeset: r.changeset, applied: true };
}

export const RISK_LABEL = { aditivo: "aditivo", ajuste: "ajuste", sensivel: "sensível", destrutivo: "destrutivo" } as const;
export const STATUS_LABEL = { pending: "pendente", applied: "aplicado", rejected: "rejeitado", rolled_back: "desfeito" } as const;
